import request from '@/utils/request'

export function saveKeyLicense(keyCompany) {
  return request({
    url: '/api/home/keylicense/saveKeyCompany',
    method: 'post',
    data: keyCompany
  })
}


export function getKeyLicenseById(companyId) {
  return request({
    url: '/api/home/keylicense/getkeylicensebyid',
    method: 'post',
    params: {
      companyId: companyId
    }
  })
}

//根据jrkey.key文件生成key
export function getCpuIdByJrkey(jrKey) {
  return request({
    url: '/api/home/keylicense/getcpuidbyjrkey',
    method: 'post',
    params: {
      jrKey: jrKey
    }
  })
}






// WEBPACK FOOTER //
// ./src/api/keylicence.js